var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"list-view-phantom",style:({
    width: _vm.contentWidth + 'px'
  })}),_vm._v(" "),_c('div',{ref:"content",staticClass:"list-view-content",class:{ header:_vm.type === 'header' }},_vm._l((_vm.visibleData),function(col,index){return _c('div',{key:index,staticClass:"list-view-item",style:({
      width: _vm.sizeAndOffsetCahce[_vm.startIndex + index].size + 'px'
    })},[_vm._t("default",null,{"col":col,"index":index})],2)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }